import { IconType } from '@mhgo/front';

export const EntityIcon: Record<string, IconType> = {
  ITEMS: 'Armory',
  MATERIALS: 'ItemBox',
  HABITATS: 'Tree',
  MONSTERS: 'Monster',
  RESOURCES: 'Star',
  QUESTS: 'Quest',
  USERS: 'Friends',
};
